export const appName = 'leads';
